import { Grid, Typography } from "@mui/material"
import { FunctionComponent, SVGProps, useState } from "react"
import { useNavigate } from "react-router-dom"
import useGlobalStore from "../../stores/global"
import { CompactTable, StyledPaper } from "../commons"
import { SearchBox, constructMarketTable, tableHeadersMarket } from "./table"

export interface MarketTableType {
  title: string
}

function createData(
  icon: FunctionComponent<SVGProps<SVGSVGElement>>,
  asset: string,
  name: string,
  price: number,
  totalSupplied: number,
  totalSuppliedCap: number,
  supplyApy: number,
  totalBorrowed: number,
  totalBorrowedCap: number,
  borrowApy: number,
  utilizationRate: number,
  contractAddress: `0x${string}`
) {
  return { icon, asset, price, totalSupplied, supplyApy, totalBorrowed, borrowApy, utilizationRate, totalSuppliedCap, totalBorrowedCap, name, contractAddress };
}

const MarketTable = (props: MarketTableType) => {
  const { title } = props
  const [search, setSearch] = useState('')
  const navigate = useNavigate()
  const markets = useGlobalStore((state) => state.markets)
  const tableRows = markets.map((market) => {
    return createData(
      market.icon,
      market.asset,
      market.name,
      market.price,
      market.totalSupplied,
      market.totalSuppliedCap,
      market.supplyApy,
      market.totalBorrowed,
      market.totalBorrowedCap,
      market.borrowApy,
      market.utilizationRate,
      market.contractAddress
    )
  }).sort((a, b) => b.totalSupplied - a.totalSupplied).filter((market) => market.asset.toLowerCase().includes(search.toLowerCase())
    || market.name.toLowerCase().includes(search.toLowerCase()))
  const optionUI = <SearchBox callback={setSearch} />
  const tableMarketData = constructMarketTable(tableRows, navigate)

  return (
    <Grid item container>
      <StyledPaper color='primary' transparent sx={{
        minWidth: '100%',
        width: '100%',
        borderRadius: 1,
        padding: '0px', //to show border
      }}>
        <Grid container flexDirection={'column'} gap={0}>
          <StyledPaper color='primary' sx={{
            padding: '1rem 1.5em',
            minWidth: '12.8rem',
            width: '100%',
            border: 0,
            borderRadius: 0
          }}>
            <Typography variant="h6" color='text.primary'>
              {title}
            </Typography>
          </StyledPaper>
          <StyledPaper
            color='primary'
            sx={{
              paddingTop: '1rem',
              width: '100%',
              border: 0,
              borderRadius: 0
            }}
            transparent
          >
            <Grid container alignItems={'center'}
              justifyContent={'flex-start'}>
              <Grid item sx={{ padding: '0rem 1.5rem' }}>
                {optionUI}
              </Grid>
              <Grid item sx={{ overflowX: 'auto', marginTop: 1.5, width: '100%' }}>
                <CompactTable tableHeader={tableHeadersMarket} tableContent={tableMarketData} />
              </Grid>
            </Grid>
          </StyledPaper>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default MarketTable